<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
  <g id="Group_417" data-name="Group 417" transform="translate(-410 -223.001)">
    <g id="globe-grid-svgrepo-com" transform="translate(410 223.001)">
      <g id="Group_432" data-name="Group 432" transform="translate(0)">
        <g id="Group_419" data-name="Group 419">
          <g id="Group_418" data-name="Group 418">
            <path id="Path_21" data-name="Path 21" d="M9,18a9,9,0,1,1,9-9A9.01,9.01,0,0,1,9,18ZM9,.756A8.244,8.244,0,1,0,17.246,9,8.254,8.254,0,0,0,9,.756Z" transform="translate(-0.002)" fill="#44454d"/>
          </g>
        </g>
        <g id="Group_421" data-name="Group 421" transform="translate(0.672 8.496)">
          <g id="Group_420" data-name="Group 420">
            <rect id="Rectangle_125" data-name="Rectangle 125" width="16.656" height="1.008" fill="#44454d"/>
          </g>
        </g>
        <g id="Group_423" data-name="Group 423" transform="translate(2.075 3.593)">
          <g id="Group_422" data-name="Group 422">
            <path id="Path_22" data-name="Path 22" d="M24.85,44.763a19.374,19.374,0,0,1-7.108-1.332l.2-.965c.067.029,6.737,2.846,13.4,0l.2.966A16.959,16.959,0,0,1,24.85,44.763Z" transform="translate(-17.742 -42.466)" fill="#44454d"/>
          </g>
        </g>
        <g id="Group_425" data-name="Group 425" transform="translate(2.1 11.925)">
          <g id="Group_424" data-name="Group 424">
            <path id="Path_23" data-name="Path 23" d="M18.157,143.23l-.2-.966a18.869,18.869,0,0,1,13.8,0l-.2.965C31.49,143.2,24.819,140.384,18.157,143.23Z" transform="translate(-17.957 -140.933)" fill="#44454d"/>
          </g>
        </g>
        <g id="Group_427" data-name="Group 427" transform="translate(4.06 0.904)">
          <g id="Group_426" data-name="Group 426">
            <path id="Path_24" data-name="Path 24" d="M51.3,23.764a16.611,16.611,0,0,1-.636-16.037l.927.287a16.034,16.034,0,0,0,.636,15.461Z" transform="translate(-48.908 -7.727)" fill="#44454d"/>
          </g>
        </g>
        <g id="Group_429" data-name="Group 429" transform="translate(10.562 0.904)">
          <g id="Group_428" data-name="Group 428">
            <path id="Path_25" data-name="Path 25" d="M128.168,23.768l-.927-.288a16.034,16.034,0,0,0,.636-15.461l.927-.287A16.613,16.613,0,0,1,128.168,23.768Z" transform="translate(-127.241 -7.731)" fill="#44454d"/>
          </g>
        </g>
        <g id="Group_431" data-name="Group 431" transform="translate(8.496 0.672)">
          <g id="Group_430" data-name="Group 430">
            <rect id="Rectangle_126" data-name="Rectangle 126" width="1.007" height="17.073" fill="#44454d"/>
          </g>
        </g>
      </g>
    </g>
  </g>
</svg>
